const InputError = ({ error }) => (
  <span className="text-attention text-xs mt-1 ml-3 animate-fade-in-down">
    {error}
  </span>
);

export default InputError;
